//@flow

export const notificationsActionTypes = {
  LOAD_NUMBER_OF_NEW_NOTIFICATIONS: "LOAD_NUMBER_OF_NEW_NOTIFICATIONS",
  UPDATE_LAST_NOTIFICATIONS_VISIT_TIME: "UPDATE_LAST_NOTIFICATIONS_VISIT_TIME",
};
export type NotificationsActionType = $Keys<typeof notificationsActionTypes>;
